import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { addingSource } from 'apps/auth/actions/cardsAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { PAYMENT_BANK_ACCOUNT, PAYMENT_BANK_CARD } from 'apps/auth/constants/Constants';

import AddCardOrAccountModal from './AddCardOrAccountModal';

const AddCardOrAccountPopup = ({ popupRef = null, ...props }) => {
    const openModal = (e, source, isShowChat = false) => {
        e.preventDefault();
        popupRef.current?.close();
        props.addingSource(source, <AddCardOrAccountModal />, isShowChat);
    };

    return (
        <SimplePopup withoutBorder popupRef={popupRef} dataTestId="add-card-or-account-popup">
            <PopupButton iconName="card" text={props.cardsAddCard} onClick={(e) => openModal(e, PAYMENT_BANK_CARD, true)} />
            <PopupButton iconName="bank" text={props.cardsAddBankAccount} onClick={(e) => openModal(e, PAYMENT_BANK_ACCOUNT)} />
        </SimplePopup>
    );
};

AddCardOrAccountPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

const mapStateToProps = (state) => {
    return {
        cardsAddBankAccount: state.messages.pageMessages.cardsAddBankAccount,
        cardsAddCard: state.messages.pageMessages.cardsAddCard,
    };
};
export default connect(mapStateToProps, { addingSource })(AddCardOrAccountPopup);
